import React from 'react'
import { Shell } from '~/components/molecules/Shell'
import * as S from './styled'
import { PressRelease } from '~/services/types/PressRelease'
import { MDXRemoteSerializeResult } from 'next-mdx-remote'
import { Mdx } from '~/components/molecules/Mdx'
import { parseAndFormatDateForPresRelease } from '~/utils'

export interface Props {
  pressRelease: Omit<PressRelease, 'markdown'>
  mdx: MDXRemoteSerializeResult
  footerMdx: MDXRemoteSerializeResult
  useBanklessFooter?: boolean
}

export const Screen = ({
  pressRelease,
  mdx,
  footerMdx,
  useBanklessFooter,
}: Props) => {
  const releaseFooter = useBanklessFooter
    ? 'Custodia All rights reserved. All trademarks are the property of their respective owners.'
    : 'Custodia Bank, Inc. All rights reserved. All trademarks are the property of their respective owners.'
  return (
    <Shell>
      <S.Screen>
        <S.ContentWrapper>
          <S.PressReleaseDate>
            {parseAndFormatDateForPresRelease(pressRelease.date)}
            {/* ex: July 12th, 2022*/}
          </S.PressReleaseDate>
          <S.PressReleaseTitle>{pressRelease.title}</S.PressReleaseTitle>
          <S.PressReleaseContent>
            <Mdx mdx={mdx} />
          </S.PressReleaseContent>
          <S.PressReleaseFooter>
            <Mdx mdx={footerMdx} />
            <S.PressReleaseFooterCopyright>
              &copy; {new Date().getFullYear()} {releaseFooter}
            </S.PressReleaseFooterCopyright>
          </S.PressReleaseFooter>
        </S.ContentWrapper>
      </S.Screen>
    </Shell>
  )
}
